import React from 'react'
import "../../styles/matchStatsH2HCard.css"

export default function MatchStatsH2HCard({ stats }) {
    const h2hResult = stats.h2h.find(e => e.stat_key === "homeXaway");

    const homeWins = h2hResult?.home_value ?? 0;
    const awayWins = h2hResult?.away_value ?? 0;

    const draws = 5 - homeWins - awayWins;

    return (
        <div className='h2h-card'>
            <div className='h2h-title'>
                Egymás elleni mérkőzések
            </div>

            <div className='h2h-header'>
                <img src={`/images/teams/${stats.teams.home.logo}`} alt={stats.teams.home.name} />
                <p>X</p>
                <img src={`/images/teams/${stats.teams.away.logo}`} alt={stats.teams.away.name} />
            </div>
            <div className="h2h-header-values">

                <span className={`h2h-header-stat-value ${homeWins >= awayWins ? "better" : "worse"}`}>
                    {homeWins}
                </span>

                <span>
                    {draws}
                </span>

                <span className={`h2h-header-stat-value ${awayWins >= homeWins ? "better" : "worse"}`}>
                    {awayWins}
                </span>

            </div>

            <div className='h2h-stat-list'>
                {stats.h2h.map((stat) => {
                    const homeBetter = stat.home_value >= stat.away_value;
                    const awayBetter = stat.away_value >= stat.home_value;

                    return (
                        <div className='h2h-stat-row'>
                            <span className={`h2h-stat-value ${homeBetter ? "better" : "worse"}`}>
                                {stat.unit === "%"
                                    ? Math.trunc(stat.home_value) + stat.unit
                                    : stat.home_value + stat.unit
                                }
                            </span>

                            <span className='h2h-label'>
                                {stat.label}
                            </span>

                            <span className={`h2h-stat-value ${awayBetter ? "better" : "worse"}`}>
                                {stat.unit === "%"
                                    ? Math.trunc(stat.away_value) + stat.unit
                                    : stat.away_value + stat.unit
                                }
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    )
}
